import { ICurrentAccount } from 'common/core/interfaces/currentAccount'

export const getAppCurrentAccount = (state: RootState): ICurrentAccount | undefined =>
  state.app.currentAccount

export const getIsAccountAdsEnabled = (state: RootState): boolean =>
  getAppCurrentAccount(state)?.is_ads_enabled ?? false

export const getAccountCreationDate = (state: RootState) => state.app.currentAccount.ts_added
